<!-- //
商城-商品-列表
@auth xuyd
@date 2024-10-01
//-->
<template>
  <page-layout layout="C">
    <!-- 检索区域 -->
    <div class="layout-search" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
               label-width="100px">
        <el-form-item prop="search">
          <el-input
              v-model="queryParams.search"
              placeholder="请输入检索内容（文件名）"
              style="width: 320px;text-align: right;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
        <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus">添加</el-button>
      </div>
    </div>

    <div class="layout-result" style="height: calc(100% - 63px);">
      <DynamicTable :query-params="queryParams"
                    :selection="true"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
        <div slot-scope="{row, item}">
          <el-button size="small" type="text" @click="handleView(row)">编辑</el-button>
        </div>
      </DynamicTable>
    </div>
  </page-layout>
</template>

<script>
import ProductApi from '@/api/mall/product.api.js';

export default {
  name: 'ViewMallProductMgmtProductList',
  components: {},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'MALL_PRODUCT_STATUS', dataType: Number},
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      tableMetas: [
        {prop: 'id', label: "商品编号", width: 120, sortable: true},
        {prop: 'name', label: "商品名称", minWidth: 150, dataType:"link", linkUrl:"ViewMallProductMgmtProductDetail", sortable: true},
        {prop: 'barCode', label: "商品条码", width: 100},
        {prop: 'imageUrl', label: "缩略图", width: 100, dataType: 'custom', customComp: "ImageView"},
        {prop: 'categoryName', label: "分类名", width: 120, sortable: true},
        {prop: 'mchName', label: "商户名称", minWidth: 150, sortable: true},
        {prop: 'brand', label: "品牌", width: 120},
        {prop: 'tag', label: "标签", width: 120},

        {prop: 'status', label: "状态", width: 120, dataType: 'dict', dictType: "MALL_PRODUCT_STATUS"},
        {prop: 'costPrice', label: "成本价", width: 120},// 合并到一个column显示
        {prop: 'salePrice', label: "销售价", width: 120},
        {prop: 'marketPrice', label: "市场价", width: 120},

        {prop: 'storeCount', label: "库存", width: 120},
        {prop: '', label: "操作", width: 150, fixed: 'right'},
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      ProductApi.searchSpuList(this.queryParams).then(resp => {
        this.tableData.records = resp.data.records.map(item => {
          item.loading = false;
          return item;
        });
        this.tableData.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleAdd() {
      this.$router.push({name: 'ViewMallProductMgmtProductDetail', query: {id: null}});
    },
    handleEdit(row) {
      this.$router.push({name: 'ViewMallProductMgmtProductDetail', query: {id: row.id}});
    },
  }
}
</script>
